"use client";

import { useState } from "react";

export function useShareDialog(title: string, url: string | undefined) {
 const [isOpen, setIsOpen] = useState(false);
 const [copiedLink, setCopiedLink] = useState(false);

 const shareUrl =
  url || (typeof window !== "undefined" ? window.location.href : "");

 const copyToClipboard = async () => {
  try {
   await navigator.clipboard.writeText(shareUrl);
   setCopiedLink(true);
   setTimeout(() => setCopiedLink(false), 2000);
  } catch {
  }
 };

 const shareViaNative = async () => {
  if (navigator.share) {
   try {
    await navigator.share({
     title: title,
     url: shareUrl,
    });
    setIsOpen(false);
   } catch {
   }
  }
 };

 return {
  isOpen,
  open: () => setIsOpen(true),
  close: () => setIsOpen(false),
  copiedLink,
  shareUrl,
  copyToClipboard,
  shareViaNative,
 };
}
